"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const utils_1 = require("./utils");
const alphaNumeric = utils_1.combinePatterns(types_1.Pattern.ALPHA, types_1.Pattern.NUMERIC);
exports.TokenPattern = new Map();
exports.TokenPattern.set(types_1.Chars.Alpha, types_1.Pattern.ALPHA);
exports.TokenPattern.set(types_1.Chars.AlphaLower, types_1.Pattern.ALPHA_LOWER);
exports.TokenPattern.set(types_1.Chars.Numeric, types_1.Pattern.NUMERIC);
exports.TokenPattern.set(types_1.Chars.Special, types_1.Pattern.SPECIAL);
exports.TokenPattern.set(types_1.Chars.AlphaNumeric, alphaNumeric);
exports.TokenPattern.set(types_1.Chars.AlphaNumericLower, utils_1.combinePatterns(types_1.Pattern.ALPHA_LOWER, types_1.Pattern.NUMERIC));
exports.TokenPattern.set(types_1.Chars.Full, utils_1.combinePatterns(alphaNumeric, types_1.Pattern.SPECIAL));
